/* eslint-disable react/react-in-jsx-scope */
import { getSafeRandom, tinperClsPrefix } from '@platform/api';
// 比较两个值(基本类型值或对象）是否一样
export function compare(a, b) {
    if (typeof a === 'object' && typeof b === 'object') {
        if (a && b) {
            // 去掉undefined
            a = JSON.parse(JSON.stringify(a));
            b = JSON.parse(JSON.stringify(b));
            var akeys = Object.keys(a),
                bkeys = Object.keys(b);
            if (akeys.length === bkeys.length) {
                for (var i = 0, l = akeys.length; i < l; i++) {
                    var flag = compare(a[akeys[i]], b[akeys[i]]);
                    if (!flag) {
                        return false;
                    }
                }
                return true;
            } else {
                return false;
            }
        } else {
            return Object.is(a, b);
        }
    } else {
        return a == b;
    }
}

// 比较两个数组是否含有同样的值
export function compareArr(arr1, arr2) {
    if (!(Array.isArray(arr1) && Array.isArray(arr2))) {
        return false;
    }
    if (arr1.length !== arr2.length) {
        return false;
    }
    arr1.sort();
    arr2.sort();
    let flag = true;
    for (let i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) {
            flag = false;
            break;
        }
    }
    return flag;
}

/**
 * @desc 判断是否执行onEnter函数
 * @param containerDom {dom} 父容器
 * @param currentTarget {dom} 当前事件源
 * @param onEnter {function} onEnter 函数
 * @return {Boolean} true -> execute, false -> stop
 */
export function executeEnterEvent({ containerDom, currentTarget, onEnter }) {
    let contains = containerDom && containerDom.contains(currentTarget);
    let result = (contains || currentTarget.tagName === 'TD') && onEnter;
    containerDom = null;
    currentTarget = null;
    return result;
}

/**
 *
 * @param direction 窗口缩放方向
 * @return {boolean} true -> 在y轴上进行缩放 false -> 在x轴上进行缩放
 */
export function resizeOnVertical(direction) {
    return direction !== 'left' && direction !== 'right';
}

/**
 * @desc 计算窗口大小调整最小值
 * @return {number}
 */
export function calculateMinWidth({
    refType,
    max,
    activeKey,
    isExpandLeftArea,
}) {
    if (refType === 'gridTree' && activeKey == 1) {
        return 1020;
    }

    let width = 0;
    if (refType !== 'grid') {
        if (refType === 'tree' && !max) {
            width += 640;
        } else if (isExpandLeftArea && !max) {
            width += 1020;
        } else {
            width += 240;
        }
    }

    if (refType !== 'tree') {
        if (refType === 'grid') {
            width += 640;
        } else if (!isExpandLeftArea) {
            // 左树展开时，右表宽度为0——liyxt
            width += 780;
        }
    }
    return width;
}

/**
 * @desc 生成唯一样式为了防止拖拽时定位出错
 */
export function getUniqueClass() {
    return 'unique-' + (new Date().getTime() + parseInt(getSafeRandom() * 10));
}

/**
 * @desc 设置容器的样式
 * @param container
 * @param styles 样式
 */
export function setContainerStyle({ container, ...styles }) {
    if (container) {
        let styleKeys = Object.keys(styles);
        styleKeys.forEach((item) => {
            container.style[item] = styles[item];
        });
        container = null;
    }
}

/**
 *
 * @param isMultiSelectedEnabled {boolean} 是否多选
 * @param valueLength {number} 值的长度
 * @param focusFromPopoverBlur {boolean} 聚焦事件是否来自popoverBlur
 * @return {boolean} true -> 显示 false -> 隐藏
 */
export function perceptionDropDownShow(
    isMultiSelectedEnabled,
    valueLength,
    focusFromPopoverBlur
) {
    if (focusFromPopoverBlur) {
        return false;
    }

    return !(isMultiSelectedEnabled && valueLength > 0);
}

/**
 * @desc 弹窗需要一直要显示在可视区域内
 * @param e {object} 事件源
 * @param draggableData {object} 拖拽信息
 */
export function modalAlwaysShowInView(e, draggableData) {
    //窗口在浏览器剩余可视距离
    const interval = 50;

    let { node } = draggableData;
    let resizeContainer = node.querySelector('.js-resize-container');

    if (resizeContainer === null) {
        return;
    }

    let { left, top, width, height, right, bottom } =
        resizeContainer.getBoundingClientRect();
    let { x, y } = draggableData;

    //向左拖动
    if (draggableData.x < 0 && left < 0) {
        x = draggableData.x - left;
    }

    //向右拖动
    if (draggableData.x > 0 && right > document.body.clientWidth) {
        if (width > document.body.clientWidth) {
            x = 0;
        } else {
            x = draggableData.x - (right - document.body.clientWidth);
        }
    }

    //向上拖动
    if (draggableData.y < 0 && top < 0) {
        y = draggableData.y - top;
    }

    //向下拖动
    if (draggableData.y > 0 && bottom > document.body.clientHeight) {
        if (height > document.body.clientHeight) {
            y = 0;
        } else {
            y = y - (bottom - document.body.clientHeight);
        }
    }
    //设值
    this.setState({ dragStartPosition: { x, y } });
}

/**
 * @desc 计算input外框的样式
 * @param disabled
 * @param focusFlag
 */
export function perceptionInputContainerClass(disabled, focusFlag) {
    let className = '';

    className = disabled ? 'refer-input-disabled' : 'refer-input-common';

    className += focusFlag ? ' refer-input-focus' : '';

    return className;
}

/**
 * @desc 计算容器高度
 * @param container
 * @param type 类型：open/close
 * @return {*}
 */
export function calculateResizeContainerHeight(container, type) {
    let referContentDom =
        container && container.querySelector('.refer-content-area');

    if (referContentDom) {
        let resizeContainer = container.querySelector('.js-resize-container');
        let dragContainer = container.querySelector('.js-drag-wrapped');

        let referHeaderDom = container.querySelector('.refer-header');
        let headerHeight = referHeaderDom ? (referHeaderDom.offsetHeight || 40) : 0;

        let bottomDom = container.querySelector('.refer-bottom');
        let bottomHeight = bottomDom ? (bottomDom.offsetHeight || 47) : 0;

        // 会导致弹窗关闭时 突然变高
        // let contentHeight = type === 'close' ? parseInt(dragContainer.style.height) : parseInt(referContentDom.style.height);
        let contentHeight =
            type === 'close'
                ? parseInt(referContentDom.style.height)
                : parseInt(referContentDom.style.height);

        let height = contentHeight + headerHeight + bottomHeight;

        resizeContainer.style.height = height + 'px';
        resizeContainer.style.minHeight = height + 'px';
        dragContainer.style.height = height + 'px';
        referContentDom =
            referHeaderDom =
            bottomDom =
            resizeContainer =
            dragContainer =
                null;

        return height;
    }
}

/**
 * @desc 删除dom的引用
 * @param self
 * @param domList
 */
export function clearDomReference(self, domList) {
    domList.map((dom) => delete self[dom]);
}

/**
 *
 * @return {boolean}
 */
export function executePopOverEnterSelect({ isShow, lifecycleStatus }) {
    return isShow === false || lifecycleStatus === 'unmount';
}

/**
 * @desc 处理样式，弹窗内的输入框触发搜索时处理左侧树上的聚焦样式
 */
export function dealTreeFocusItem(refTree) {
    // 暂时改不了 需要tinper提供支持方案
    const FOCUS_ITEM_CLASS = `${tinperClsPrefix}-tree-treenode-focused`;
    const SELECT_ITEM_CLASS = `${tinperClsPrefix}-tree-treenode-selected`;
    let treeNode = refTree.querySelector(`.${FOCUS_ITEM_CLASS}`);

    if (treeNode && !treeNode.className.includes(SELECT_ITEM_CLASS)) {
        let reg = new RegExp(FOCUS_ITEM_CLASS);
        treeNode.className = treeNode.className.replace(reg, '');
    }

    treeNode = null;
}

/**
 * @desc CLOUD-170793
 * @param direction {string} 方向
 * @param ref {dom}
 */
export function needClearTransformPosition({ direction, ref }) {
    if (direction === 'top') {
        let height = parseInt(ref.style.height);
        let minHeight = parseInt(ref.style.minHeight);

        return height <= minHeight;
    }
}

export function calculateTransformPosition(ref) {
    let reg = /(\d+\w+, \d+\w+)/;
    let matchResult =
        ref.style.transform && ref.style.transform.match(reg)[0].split(',');

    if (matchResult) {
        let currentTransformX = matchResult[0];
        return `translate(${currentTransformX}, 0px)`;
    }
}

// search lighthigh

export function countTitle(title, treeSearchKey) {
    if (treeSearchKey && treeSearchKey.length > 0 && typeof title == 'string') {
        let lowerCaseTitle = title.toLowerCase(),
            lowerCaseTreeSearchKey = treeSearchKey.toLowerCase();
        const idx = lowerCaseTitle.indexOf(lowerCaseTreeSearchKey);
        if (idx > -1) {
            title = (
                <span>
                    {title.substr(0, idx)}
                    <span className="refer-seatch-heightlight">
                        {title.substr(idx, treeSearchKey.length)}
                    </span>
                    {title.substr(idx + treeSearchKey.length)}
                </span>
            );
        }
    }
    return title;
}

export function isSafari() {
    return (
        navigator.userAgent.indexOf('Safari') > -1 &&
        navigator.userAgent.indexOf('Chrome') == -1
    ); //判断是否Safari浏览器
}
/**
 * @desc 处理键盘按下事件
 * @param context {object} 执行上下文
 * @param callBack {function} 回调
 * @param e {object} 事件源
 * @param status {object} 状态
 */
export function handleArrowKeyDown({ context, callBack, e, status }) {
    let { renderInTable } = context.props;
    let { historySelectionVisible, isSearchStatus, isSelectedStatus } = status;

    if (renderInTable !== true && callBack === undefined) {
        return;
    }

    let noShow =
        !(historySelectionVisible || isSearchStatus || isSelectedStatus) ||
        !context.state.dropDownShow;

    /*Object.defineProperty(e, 'keyCode', {
        set () {
            debugger;
        }
    })*/

    /*
     * issue: 在定时器中得到的事件源的属性全部为null, 断点发现是react-dom内部把事件源对象的全部属性设为了null，可以打开上面的注释去调试
     * 推测: 可能是setState导致组件状态更新，react-dom 更新dom引起
     * 验证: demo/memoryLeak/blank.js:104
     * resolve: 现只能在定时器之前保存需要的值
     * */

    let keyCode = e.keyCode;
    let target = e.target;

    let timer = setTimeout(() => {
        if (keyCode === 37 || keyCode === 39) {
            //按左右键跟下拉框的上下键快捷键不冲突所以不做判断，直接跳转
            callBack && callBack({ e: { keyCode, target } });
        } else {
            // 如果下拉框是展开状态就不执行上下键跳转
            !context.state.isShow &&
                noShow &&
                callBack &&
                callBack({ e: { keyCode, target } });
        }

        clearTimeout(timer);
    }, 20);
}

/**
 * @desc 表格支持多行选中时在第一行按上键就需要聚焦到表头的checkbox中
 * @param selectedRowIndex {number} 当前选中行
 * @param isMultiSelectedEnabled {boolean} 表格行是否支持多选
 * @return {boolean} 返回将要选中的行索引
 */
export function perceptionRowIndexWithUp(
    selectedRowIndex,
    isMultiSelectedEnabled
) {
    return isMultiSelectedEnabled && selectedRowIndex === 0
        ? -1
        : selectedRowIndex;
}

/**
 * @desc 表格支持多行选中时在最后一行按下键就需要聚焦到表头的checkbox中
 * @param selectedRowIndex {number} 当前选中行
 * @param isMultiSelectedEnabled {boolean} 表格行是否支持多选
 * @param tableDataLen {number} 表格的行数
 * @return {number} 返回将要选中的行索引
 */
export function perceptionRowIndexWithDown(
    selectedRowIndex,
    isMultiSelectedEnabled,
    tableDataLen
) {
    return isMultiSelectedEnabled && selectedRowIndex === tableDataLen
        ? -1
        : selectedRowIndex;
}

/**
 * @desc 表格支持多行选中时在第一行按上键就需要聚焦到表头的checkbox中
 * @param selectedRowIndex {number} 当前选中行
 * @param isMultiSelectedEnabled {boolean} 表格行是否支持多选
 * @return {boolean} 返回将要选中的行索引
 */
export function perceptionRowIndexDropWithUp(
    selectedRowIndex,
    isMultiSelectedEnabled
) {
    return selectedRowIndex;
}

/**
 * @desc 表格支持多行选中时在最后一行按下键就需要聚焦到表头的checkbox中
 * @param selectedRowIndex {number} 当前选中行
 * @param isMultiSelectedEnabled {boolean} 表格行是否支持多选
 * @param tableDataLen {number} 表格的行数
 * @return {number} 返回将要选中的行索引
 */
export function perceptionRowIndexDropWithDown(
    selectedRowIndex,
    isMultiSelectedEnabled,
    tableDataLen
) {
    return selectedRowIndex;
}

/**
 * @desc 聚焦到表头的checkbox
 * @param tableDom {dom}
 * @param spaceKeyDown {boolean} space键是否是按住状态
 */
export function focusToTableHeadCheckBox(tableDom, spaceKeyDown) {
    // 不需要限定左边  参照表格 不可编辑
    let checkbox =
        tableDom && tableDom.querySelector(`.refer-table-head-checkbox input`);
    checkbox.focus();

    if (spaceKeyDown) {
        checkbox.click();
    }
}

const tableRowHeight = 28;

/**
 * @desc 让表格最后一行获取focus状态, 如果space是keyDown状态就选中最后一行
 * @param tableDataLen {number} 表格的行数
 * @param tableBody {dom}
 */
export function selectToLastRow({ tableDataLen, tableBody }) {
    let selectedRowIndex = tableDataLen;
    if (
        tableBody &&
        (selectedRowIndex + 1) * tableRowHeight >
            tableBody.clientHeight + tableBody.scrollTop
    ) {
        this.scrollTop =
            (selectedRowIndex + 1) * tableRowHeight - tableBody.clientHeight;
    }

    if (this.spaceKeyDown) {
        let { selectedValues, tableData } = this.state,
            row = tableData[0].rows[selectedRowIndex];

        this.toggleValueForMapOrObject(selectedValues, row.refpk, row);
        this.setState({
            isMultiSelectMode: true,
            selectedValues,
        });
    }

    this.setState({ selectedRowIndex: tableDataLen });
}

/**
 * @desc 让表格第一行获取focus状态，如果space是keyDown状态就选中第一行
 */
export function selectToFirstRow() {
    this.scrollTop = 0;
    if (this.spaceKeyDown) {
        let { selectedValues, tableData } = this.state,
            row = tableData[0].rows[0];

        this.toggleValueForMapOrObject(selectedValues, row.refpk, row);
        this.setState({
            isMultiSelectMode: true,
            selectedValues,
        });
    }

    this.setState({ selectedRowIndex: 0 });
}
